export const baseURL = "https://traxxapi.azurewebsites.net";
//export const baseURL = "http://192.168.86.22:5001";
//export const baseURL = "https://dev.gentroo.com:25691";
export const portalURL = "https://portal.soiltraxx.ca";
//export const portalURL = "http://localhost:19006";
export const googlePlayURL = "http://localhost:19006";
export const appleAppStoreURL = "http://localhost:19006";
export const placesBaseURL = 'https://maps.googleapis.com/maps/api/place';